import { mapGetters, mapActions, mapMutations } from "vuex";

import {
    GET_LANGUAGE_LIST,
    LOGOUT,
    GET_CATEGORIES_MENU,
    GET_ADVANTAGE_LIST,
    GET_FAVORITES_LIST,
    GET_CONTACTS
} from '@/store/action-types';
import {
    CHANGE_OPEN_MENU,
    CHANGE_OPEN_SECOND_MENU,
    CHANGE_OPEN_FIRST_MENU
} from '@/store/mutation-types';

import HeaderSearch from '../header-search/index.vue'
import HeaderCatalog from '../header-catalog/index.vue'
import CatalogList from '@/components/catalog-list-mobile/index.vue';

import Moment from 'moment';
import {extendMoment} from 'moment-range';
const moment = extendMoment(Moment);

export default {
    name: 'main-header',
    data(){
        return {
            active: false,
            options: {

            }
        }
    },
    components: {
        HeaderSearch,
        HeaderCatalog,
        CatalogList
    },
    computed: {
        ...mapGetters({
            locales: `setting/locales`,
            whichList: `favorites/whichList`,
            favoritesList: 'favorites/list',
            basket: `basket/basket`,
            countBasketItems: `basket/countBasketItems`,
            isAuthenticated: `auth/isAuthenticated`,
            isOpenMenu: `system/openMenu`,
            isOpenSecondMenu: `system/openSecondMenu`,
            isOpenFirstMenu: `system/openFirstMenu`,
            propsSecondMenu: `system/propsSecondMenu`,
            config: 'setting/menu',
            contacts: 'contacts/contacts',
            user: 'profile/user',
        }),
        ...mapGetters([
            'languages',
            'currentLanguage',
        ]),
        changeWord(){
            let titles = [this.$t('basketProducts'), this.$t('basketProducts1'), this.$t('basketProducts2')];
            let cases = [2, 0, 1, 1, 1, 2];
            return titles[ (this.countBasketItems()%100>4 && this.countBasketItems()%100<20)? 2 : cases[(this.countBasketItems()%10<5)?this.countBasketItems()%10:5] ];
        },
        totalPriceBasket(){
            let total = 0;
            if(this.isAuthenticated){
                if(this.user.inner){
                    this.basket.forEach(e => {
                        const remainder = e.days % 60;
                        const iterationValue = (e.days - remainder) / 60;
                        const amountWithIterations = (iterationValue * (e.price / 2)) * e.selectCount;
                        total = total + amountWithIterations;
                        const amountRemainder = remainder * e.price_rent;
                        if(amountRemainder >= (e.price / 2) ){
                            total = total + ((e.price / 2) * e.selectCount);
                        }else{
                            total = total + (amountRemainder * e.selectCount);
                        }
                    });
                }else{
                    this.basket.forEach(e => {
                        total = total + e.totalPrice;
                    });
                }
            }else{
                this.basket.forEach(e => {
                    total = total + e.totalPrice;
                });
            }
            return total;
        },
        totalWarrantyPrice(){
            let price = 0;
            if(this.isAuthenticated){
                if(!this.user.inner){
                    this.basket.forEach(e => {
                        price = price + e.warrantyAmount;
                    });
                }
            }else{
                this.basket.forEach(e => {
                    price = price + e.warrantyAmount;
                });
            }

            return price;
        },
        countFavoritesProduct(){
            let count = 0;
            if(this.favoritesList){
                this.favoritesList.forEach(e => {
                    e.products.data.forEach(t => {
                        count = t.count + count
                    })
                })
            }
           return count;
        },
        currentLogo(){
            switch (this.currentLanguage.key) {
                case 'uk': {
                    return require('../../assets/img/logo-uk.png');
                    break;
                }
                default: {
                    return require('../../assets/img/logo.png');
                    break;
                }
            }
        },
        currentLogoMob(){
            switch (this.currentLanguage.key) {
                case 'uk': {
                    return require('../../assets/img/logo_ukr_white_mob.png');
                    break;
                }
                default: {
                    return require('../../assets/img/logo-white.png');
                    break;
                }
            }
        },
        transformWhichList() {
            let result = [];
            this.whichList.forEach(e => {
                result.push(e.id)
            });
            return result;
        }
    },
    created(){
        moment.locale(this.$route.params.lang);
        this.fetchLanguage();
        this.fetchFavorites({list: this.transformWhichList});
    },
    methods: {
        ...mapActions({
            fetchLanguage: `setting/${GET_LANGUAGE_LIST}`,
            fetchCotacts: `contacts/${GET_CONTACTS}`,
            logout: `auth/${LOGOUT}`,
            fetchCategories: `setting/${GET_CATEGORIES_MENU}`,
            fetchAdvantageList: `home/${GET_ADVANTAGE_LIST}`,
            fetchFavorites: `favorites/${GET_FAVORITES_LIST}`
        }),
        ...mapMutations({
            changeMenu: `system/${CHANGE_OPEN_MENU}`,
            changeShowSecondMenu: `system/${CHANGE_OPEN_SECOND_MENU}`,
            changeShowFirstMenu: `system/${CHANGE_OPEN_FIRST_MENU}`,
        }),
        changeMenuBurger(){
            if(this.isOpenMenu){
                this.changeMenu(false)
            }else{
                this.changeMenu(true)
            }
        },
        getContactItem(key){
            return this.contacts.filter(e => {
                if(e.type === key){
                    return e;
                }
            });
        },
        changeLanguage(code){
            this.$setLanguage(code);
            this.fetchCategories();
            if(this.$route.name === 'home'){
                this.fetchAdvantageList();
            }
            if(this.$route.name === 'contacts'){
                this.fetchCotacts();
            }
            this.fetchLanguage();
            setTimeout(() => {
                moment.locale(this.currentLanguage.key);
            }, 200);
        },
        removeToken(){
            this.logout();
            this.$router.push({ name: 'home' })
        }
    }
}
